<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm p-8">
    <div class="max-w-4xl mx-auto">
      <h1 class="text-4xl font-bold gradient-text mb-8 text-center">
        主题测试页面
      </h1>
      
      <!-- 当前主题信息 -->
      <div class="card p-6 mb-8">
        <h2 class="text-2xl font-semibold text-psychology-primary mb-4">当前主题信息</h2>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <span class="font-medium">主题名称:</span>
            <span class="ml-2 text-psychology-secondary">{{ currentThemeName }}</span>
          </div>
          <div>
            <span class="font-medium">主题描述:</span>
            <span class="ml-2 text-psychology-accent">{{ currentThemeDescription }}</span>
          </div>
        </div>
      </div>
      
      <!-- 颜色展示 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="card p-4 text-center">
          <div class="w-16 h-16 bg-psychology-primary rounded-lg mx-auto mb-3"></div>
          <h3 class="font-semibold text-psychology-primary">主色调</h3>
          <p class="text-sm text-gray-600">psychology-primary</p>
        </div>
        
        <div class="card p-4 text-center">
          <div class="w-16 h-16 bg-psychology-secondary rounded-lg mx-auto mb-3"></div>
          <h3 class="font-semibold text-psychology-secondary">辅助色</h3>
          <p class="text-sm text-gray-600">psychology-secondary</p>
        </div>
        
        <div class="card p-4 text-center">
          <div class="w-16 h-16 bg-psychology-accent rounded-lg mx-auto mb-3"></div>
          <h3 class="font-semibold text-psychology-accent">强调色</h3>
          <p class="text-sm text-gray-600">psychology-accent</p>
        </div>
        
        <div class="card p-4 text-center">
          <div class="w-16 h-16 bg-psychology-warning rounded-lg mx-auto mb-3"></div>
          <h3 class="font-semibold text-psychology-warning">警告色</h3>
          <p class="text-sm text-gray-600">psychology-warning</p>
        </div>
      </div>
      
      <!-- 透明度测试 -->
      <div class="card p-6 mb-8">
        <h2 class="text-2xl font-semibold text-psychology-primary mb-4">透明度测试</h2>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div class="p-4 bg-psychology-primary-5 rounded-lg border border-psychology-primary-20">
            <span class="text-sm font-medium">5% 透明度</span>
          </div>
          <div class="p-4 bg-psychology-primary-10 rounded-lg border border-psychology-primary-20">
            <span class="text-sm font-medium">10% 透明度</span>
          </div>
          <div class="p-4 bg-psychology-primary-20 rounded-lg border border-psychology-primary-20">
            <span class="text-sm font-medium">20% 透明度</span>
          </div>
          <div class="p-4 bg-psychology-primary-50 rounded-lg border border-psychology-primary-20">
            <span class="text-sm font-medium">50% 透明度</span>
          </div>
        </div>
      </div>
      
      <!-- 按钮测试 -->
      <div class="card p-6 mb-8">
        <h2 class="text-2xl font-semibold text-psychology-primary mb-4">按钮测试</h2>
        <div class="flex flex-wrap gap-4">
          <button class="btn-primary">主要按钮</button>
          <button class="btn-secondary">次要按钮</button>
          <button class="px-4 py-2 bg-psychology-accent hover:bg-psychology-accent-90 text-white rounded-md transition-colors">
            强调按钮
          </button>
          <button class="px-4 py-2 bg-psychology-warning hover:bg-psychology-warning-90 text-white rounded-md transition-colors">
            警告按钮
          </button>
        </div>
      </div>
      
      <!-- 渐变文本测试 -->
      <div class="card p-6">
        <h2 class="text-2xl font-semibold text-psychology-primary mb-4">渐变文本测试</h2>
        <p class="text-3xl font-bold gradient-text mb-4">
          恋爱占有欲指数计算器
        </p>
        <p class="text-lg gradient-text">
          专业的恋爱心理评估工具，基于多个经过验证的心理测量量表
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentTheme, getThemeName } from '@/utils/themeUtils'

export default {
  name: 'ThemeTestPage',
  computed: {
    currentThemeName() {
      return getThemeName()
    },
    currentThemeDescription() {
      return getCurrentTheme().description
    }
  }
}
</script>
